import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import {
    VerticalDetailViewTop,
    SmallViewFlex,
    ParentContainer,
    TitleComponent,
    SurgeryDiv,
    StyledSurgerySpan,
} from 'src/pages/reportUsage/header/ReportUsageHeader.styled';
import { useSelector } from 'react-redux';
import ReportUsageSubHeader from 'src/pages/reportUsage/header/ReportUsageSubHeader';
import { getDisplayDateTime } from 'src/utils/dateUtils';

const NoUsageProcedureHeader = ({
    cancelSurgeryData,
    selectedPhysicianData,
    paddingBottom,
    cancelReason
}) => {
    const dateOfSurgery = cancelSurgeryData?.surgeryDate;
    const getBrowserTimeZoneName = () => {
        return moment.tz
            .zone(moment.tz.guess())
            .abbr(new Date().getTimezoneOffset());
    };

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    return (
        <ParentContainer paddingBottom={paddingBottom}>
            <SmallViewFlex
                lg={4}
                md={4}
                mbJustifyContent={'flex-end'}
                smJustifyContent={'flex-end'}
                mbPaddingRight={'15px'}
                bannerMargin={bannerHeight}
            >
                {cancelSurgeryData ? (
                    <VerticalDetailViewTop
                        mbPaddingRight={'0'}
                        iPhoneMiniFlexRatio={'0.7'}
                        marginLeft={'2px'}
                    >
                        <TitleComponent>
                            <span className="procedure-my-case-ref-dt-mask">{cancelSurgeryData?.myCaseRef}</span>
                        </TitleComponent>
                        <SurgeryDiv>
                            Surgery:
                            <StyledSurgerySpan>
                                {getDisplayDateTime(dateOfSurgery)}{' '}
                                {getBrowserTimeZoneName()}
                            </StyledSurgerySpan>
                        </SurgeryDiv>
                    </VerticalDetailViewTop>
                ) : null}
            </SmallViewFlex>
            {window.innerWidth > sizes.mobileDevice && (
                <MultiViewComponent flexRatio={cancelReason == 'UNID_NON_USE' ? '1' : '0.6'}>
                    {cancelSurgeryData &&
                        Object.keys(cancelSurgeryData).length > 0 && (
                            <ReportUsageSubHeader
                                usageDetails={cancelSurgeryData}
                                selectedPhysicianData={selectedPhysicianData}
                            />
                        )}
                </MultiViewComponent>
            )}
        </ParentContainer>
    );
};

export default NoUsageProcedureHeader;

export const MultiViewComponent = styled.div`
    flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.5)};
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    align-items: ${(props) => (props.flexAlign ? props.flexAlign : 'center')};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'space-between'};

    ${media.smalDevice`
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 1.0)};
    `}

    ${media.mobileDevice`
        flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'column'};
        display: ${(props) => (props.displayType ? props.displayType : 'flex')};
        padding-top: ${(props) =>
            props.paddingTop ? props.paddingTop : '15px'};
        padding-bottom: ${(props) =>
            props.paddingBottom ? props.paddingBottom : '16px'};
        letter-spacing: 0px;
    `}
`;
